import * as React from 'react';
import { SVGProps } from 'react';

const IconLentaFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18v-2c-2 0-2-2-2-2V5a2 2 0 0 0-2-2H4Zm2 4v5h2V9h3V7H6Zm10 10v-5h-2v3h-3v2h5Z"
    />
  </svg>
);
export default IconLentaFilledSizeM;
